<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('xiang-qing-0')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="12">
                <el-form-item :label="$t('zhuang-lei-xing-xing-hao-0')" :label-width="formLabelWidth" prop="typeModel">
                  <label v-text="detailForm.typeModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zhuang-lei-xing-ming-cheng-0')" :label-width="formLabelWidth" prop="typeName">
                  <label v-text="detailForm.typeName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('e-ding-gong-shuai-0')" :label-width="formLabelWidth" prop="ratedPower">
                  <label v-text="detailForm.ratedPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shu-chu-dian-ya-fan-wei-vdc-0')" :label-width="formLabelWidth" prop="outputVoltageRange">
                  <label v-text="detailForm.outputVoltageRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shu-chu-dian-liu-fan-wei-a-0')" :label-width="formLabelWidth" prop="outputCurrentRange">
                  <label v-text="detailForm.outputCurrentRange"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="每把枪均充电流范围（A）：" :label-width="formLabelWidth" prop="chargingCurrentRangePerGun">-->
              <!--                      <label v-text="detailForm.chargingCurrentRangePerGun"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item :label="$t('gong-shuai-fen-pei-fang-shi-0')" :label-width="formLabelWidth" prop="powerDistributionMode">
                  <label v-if="detailForm.powerDistributionMode" v-text="detailForm.powerDistributionMode.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qiang-xian-chang-du-mi-0')" :label-width="formLabelWidth" prop="lineLength">
                  <label v-text="detailForm.lineLength"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-qiang-shu-liang-1')" :label-width="formLabelWidth" prop="gunCount">
                  <label v-text="detailForm.gunCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shi-fou-dai-guang-gao-ji-0')" :label-width="formLabelWidth" prop="advertisingMachine">
                  <label v-if="detailForm.advertisingMachine"
                         v-text="detailForm.advertisingMachine.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('mo-kuai-pin-pai-xing-hao-0')" :label-width="formLabelWidth" prop="moduleBrandModel">
                  <label v-text="detailForm.moduleBrandModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('mo-kuai-gong-shuai-kw-0')" :label-width="formLabelWidth" prop="modularPower">
                  <label v-text="detailForm.modularPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('mo-kuai-shu-liang-0')" :label-width="formLabelWidth" prop="modularCount">
                  <label v-text="detailForm.modularCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zheng-ji-zhong-liang-kg-0')" :label-width="formLabelWidth" prop="completeMachineWeight">
                  <label v-text="detailForm.completeMachineWeight"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('ruan-jian-ban-ben-hao-0')" :label-width="formLabelWidth" prop="versionNumber">
                  <label v-text="detailForm.versionNumber"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dian-liu-qu-jian-0')" :label-width="formLabelWidth" prop="currentRange">
                  <label v-text="detailForm.currentRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dian-ya-qu-jian-0')" :label-width="formLabelWidth" prop="voltageRange">
                  <label v-text="detailForm.voltageRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('gong-shuai-qu-jian-0')" :label-width="formLabelWidth" prop="powerRange">
                  <label v-text="detailForm.powerRange"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      viewVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/detail.vue